import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { config } from "../config/environment";

/**
 * EnvironmentBanner Component
 *
 * Displays a prominent banner at the top of the app for non-production environments.
 * Used to clearly indicate which environment the user is currently in.
 */
export default function EnvironmentBanner() {
  if (!config.shouldShowBanner) {
    return null;
  }

  const bannerStyle = config.isDev
    ? config.bannerConfig.dev
    : config.isPersonal
    ? config.bannerConfig.personal
    : null;

  if (!bannerStyle) {
    return null;
  }

  return (
    <Box
      bg={bannerStyle.bg}
      color={bannerStyle.color}
      py={2}
      px={4}
      textAlign="center"
      fontWeight="bold"
      fontSize="sm"
    >
      <Text>{bannerStyle.text}</Text>
    </Box>
  );
}
